import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { colors } from 'styles';
import { breakpoint } from 'utils/mediaQueries';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/basics';
import TextContactUs from './TextContactUs';
import FormModal from 'components/pages/Index/FormModals/FormModal';
import { FORM_TYPES } from 'components/pages/Index/FormModals/formConfigs';

const StyledGrid = styled(Grid)`
  height: 100%;
  text-align: left;
  padding: 1rem;
  p {
    margin: 0;
  }
  ${breakpoint.down('md')`
  text-align: center`}
`;
const ButtonGrid = styled(Grid)`
  a {
    ${breakpoint.down('md')`
    padding-left:3rem;padding-right:3rem;
  `}
  }
`;

const ContactUsBlock = ({ data, lang }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <StyledGrid container direction={'column'} justify="center">
      <TextContactUs data={data} />
      <ButtonGrid>
        <Button
          onClick={() => handleOpen()}
          variant={'contained'}
          color="primary"
          customTextColor={colors.white}
          customBackgroundColor={colors.black}
          customHoverBackgroundColor={colors.black}
          size="medium"
          mt={1}
          pl={2}
          pr={2}
        >
          <FormattedMessage id="button.contact" />
        </Button>
        <FormModal
          lang={lang}
          open={open}
          handleClose={handleClose}
          type={FORM_TYPES.CONTACT}
        />
      </ButtonGrid>
    </StyledGrid>
  );
};
export default ContactUsBlock;
